"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CaptionPath_1 = require("./CaptionPath");
var RowItem_styles_1 = require("./RowItem.styles");
exports.default = (function (_a) {
    var Item = _a.Item, IsSelected = _a.IsSelected, OnItemClick = _a.OnItemClick;
    var _b = React.useState(false), isHovered = _b[0], setHovered = _b[1];
    var handleOnClick = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        OnItemClick(Item);
    };
    return (React.createElement(RowItem_styles_1.Row, { "aria-current": IsSelected, IsHovered: isHovered, IsSelected: IsSelected, onClick: handleOnClick, onMouseEnter: function () { return setHovered(true); }, onMouseLeave: function () { return setHovered(false); } },
        React.createElement(CaptionPath_1.default, __assign({}, Item, { IsSelected: IsSelected, IsHovered: isHovered }))));
});
